import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'ADD_TO_OPER',
  title: 'Comment ajouter une entreprise sur une opération ?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur l’onglet « Opérations »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur l’opération de votre choix'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliquez en haut à droite sur « Ajouter une entreprise »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Sélectionnez le rôle de l’entreprise'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Renseignez le SIRET ou le nom de l’entreprise'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Si celle-ci est présente sur la plateforme :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Cliquez sur l’entreprise'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Puis validez pour l’ajouter à votre opération'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '7.',
    value: 'Si celle-ci n’est pas présente sur la plateforme :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Cliquez sur le bouton « Inviter l’organisation « Nom de l’entreprise » à rejoindre le réseau »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Renseignez les coordonnées de l’entreprise'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_8.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Cliquez sur valider'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_9.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Puis validez'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ADD_TO_OPER/FR_ADD_TO_OPER_11.png`
  }]
};
